import { render, staticRenderFns } from "./CCheckbox.vue?vue&type=template&id=072a1eca&scoped=true"
import script from "./CCheckbox.vue?vue&type=script&lang=ts&setup=true"
export * from "./CCheckbox.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./CCheckbox.vue?vue&type=style&index=0&id=072a1eca&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "072a1eca",
  null
  
)

export default component.exports